import React, { useState } from "react";
import "../styles/UserSettings.css";
import { FiEye, FiEyeOff } from "react-icons/fi";

const UserSettings = ({ onPrevious, onSave, initialData = {}, submitting = false }) => {
  const [data, setData] = useState({
    email: initialData.email || "",
    password: "",
    retypePassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showRetype, setShowRetype] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData({
      ...data,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const togglePassword = () => setShowPassword(!showPassword);
  const toggleRetype = () => setShowRetype(!showRetype);

  const handleSave = () => {
    onSave(data);
  };

  return (
    <div className="user-settings-form">
      <div className="form-row">
        <label>Email</label>
        <input
          type="email"
          name="email"
          value={data.email}
          onChange={handleChange}
          placeholder="Enter email"
        />
      </div>

      <div className="form-row">
        <label>Password</label>
        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={data.password}
            onChange={handleChange}
            placeholder="Enter password"
          />
          <span className="eye-icon" onClick={togglePassword}>
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>
      </div>

      <div className="form-row">
        <label>Retype Password</label>
        <div className="password-wrapper">
          <input
            type={showRetype ? "text" : "password"}
            name="retypePassword"
            value={data.retypePassword}
            onChange={handleChange}
            placeholder="Retype password"
          />
          <span className="eye-icon" onClick={toggleRetype}>
            {showRetype ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>
      </div>

      <div className="form-buttons">
        <button className="userSetting-back-btn" onClick={onPrevious} disabled={submitting}>
          Back
        </button>
        <button className="userSetting-save-btn" onClick={handleSave} disabled={submitting}>
          {submitting ? "Creating..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default UserSettings;
